import { Center, HStack, Text, VStack } from 'native-base';
import { LoginIcon, LogoutIcon } from 'react-native-heroicons/outline';

// Props
type Props = {
  joining: boolean;
  username: string;
};

export const ChatNotification = ({
  joining = true,
  username = 'Username',
}: Props) => {
  const joiningNotification = (
    <VStack bg={'red.100'} alignItems={'center'}>
      <HStack width={'3/4'} bg={'blue.400'} alignItems={'center'} space={1}>
        <LoginIcon color={'#FFFFFF'} size={20} />
        <Text variant={'username'}>sly_alice</Text>
        <Text color={'dark.darkBorder'}>
          crashlanded from a distant planet. Say hello!
        </Text>
      </HStack>
    </VStack>
  );

  const leavingNotification = (
    <Center>
      <HStack
        width={'3/4'}
        bg={'blue.400'}
        alignItems={'center'}
        space={1}
        flexWrap={'wrap'}
      >
        <LogoutIcon color={'#FFFFFF'} size={20} />
        <Text variant={'username'}>mike96</Text>
        <Text color={'dark.darkBorder'}>departed on new adventures.</Text>
      </HStack>
    </Center>
  );

  return <>{joining ? joiningNotification : leavingNotification}</>;
};
